<template lang="html">

    <div class="tile is-ancestor">
        <div class="tile is-parent">
            <div class="tile is-child box">
                <p class="title">Historial de llamadas</p>
                <section>
                    <b-field grouped group-multiline>
                        <b-select v-model="perPage" @input="getData">
                            <option value="5">5 por página</option>
                            <option value="10">10 por página</option>
                            <option value="15">15 por página</option>
                            <option value="20">20 por página</option>
                        </b-select>
                    </b-field>
                    <b-table
                            :data="data"
                            paginated
                            :loading="loading"
                            :per-page="perPage"
                            backend-pagination
                            default-sort="id"
                            backend-sorting
                            :current-page="currentPage"
                            :total="total"
                            @sort="sorted"
                            @page-change="pageChange">

                        <template slot-scope="props">
                            <b-table-column label="Acciones" width="40">
                                <action-buttons :row="props.row" primary-key="uuid" show
                                                url="/ivr/call" model="Call">
                                    <template slot-scope="item">
                                        <show-call :item="item.item"></show-call>
                                    </template>
                                </action-buttons>
                            </b-table-column>
                            <b-table-column field="from" label="Número entrante" sortable>
                                {{props.row.from}}
                            </b-table-column>
                            <b-table-column field="type" label="Tipo de llamada" sortable>
                                {{props.row.type | TypeCall}}
                            </b-table-column>
<!--                            {field: 'type', label: 'Tipo de llamada', sort: true, hasFilter: true, filter: 'TypeCall', filterAdd: null},-->
                            <b-table-column field="to" label="Operadora" sortable>
                                {{props.row.to}}
                            </b-table-column>
<!--                            {field: 'to', label: 'Operadora', sort: true, hasFilter: false, filter: '', filterAdd: null},-->
                            <b-table-column field="created_at" label="Fecha" sortable>
                                {{props.row.created_at}}
                            </b-table-column>
<!--                            {field: 'created_at', label: 'Fecha', sort: true, hasFilter: false, filter: '', filterAdd: null},-->
                            <b-table-column field="status" label="Estado">
                                <span v-html="renderStatus(props.row.status)"></span>
                                <span v-if="hasVoiceMail(props.row)" v-html="renderStatus('voice_mail')"></span>
                            </b-table-column>
<!--                            {field: 'status', label: 'status', sort: true, hasFilter: true, filter: 'status', filterAdd: null},-->
                        </template>
                    </b-table>
                </section>
            </div>
        </div>
    </div>

</template>

<script>
    import LaravelEcho from 'laravel-echo'

    export default {
        name: 'PanelAdmin',
        data() {
            return {
                url: this.$auth.check('ivr_worker') ? 'ivr/calls?list=ivr_worker' : 'ivr/calls',
                data: [],
                currentPage: 1,
                perPage: 10,
                total: 0,
                order: 'desc',
                field: 'id',
                loading: false
            }
        },
        created() {
            this.prepareComponent()
        },
        destroyed() {
            if(this.echo){
                this.echo.leave('Calls');
            }
        },
        methods: {
            prepareComponent() {
                const echo = new LaravelEcho(this.$backend.socketHeaders());
                echo.private('Calls').listen('Ivr\\NewCallEvent', e => {
                    this.getData();
                });
                this.getData()
            },
            sorted(field, order) {
                this.field = field;
                this.order = order;
                this.getData()
            },
            pageChange(page) {
                this.currentPage = page;
                this.getData()
            },
            getData() {
                this.loading = true
                this.$http.get(this.url, {
                    params: {
                        pagesize: this.perPage,
                        page: this.currentPage,
                        field: this.field,
                        sorting: this.order,
                    }
                }).then(response => {
                    this.loading = false;
                    let res = response.data;
                    this.data = res.data;
                    this.total = res.total
                }, error => {
                    this.loading = false;
                    Toast.danger(error.response.data.message)
                })
            },
            renderStatus(type) {
                let text = '';
                let color =''
                switch (type) {
                    case 'completed':
                    case 'incomplete_survey':
                    case 'interrupt':
                        text = 'Completada';
                        color ='is-success'
                        break;
                    case 'hangup':
                        text = 'Colgada';
                        color ='is-danger';
                        break;
                    case 'invalid_phone':
                        text = 'Número incorrecto';
                        color ='is-interrupt'
                        break;
                    case 'queued':
                        text = 'En espera';
                        break;
                    case 'in-progress':
                        text = 'En llamada';
                        break;
                    case 'voice_mail':
                        text = 'Mensaje de voz';
                        color = 'is-warning';
                        break;
                    case 'ringing':
                        text = 'Timbrando';
                        break;
                    default:
                        text = type;
                }
                return `<span style="color: black; min-width: 100%;" class="tag ${color}">  ${text}</span>`;
            },
            hasVoiceMail(call){
                return call.records.length > 0 && !call.worker_id && !call.user_id
            }
        }
    }
</script>
